import i18n from "../i18n";
import { FilterType } from "./enums";

export const orgId = "Rombo Logística";

export const parseErrorBody = (textBody) => {
    let parsedBody;
    try {
        const cleanedBody = textBody.replace(/\\\"/g, '"').replace(/(^"|"$)/g, '');
        const errorData = JSON.parse(cleanedBody);
        const firstError = errorData[0];
        parsedBody = firstError.msg;
    } catch (e) {
        parsedBody = textBody;
    }
    return parsedBody;
};

export const getAddressInfo = ({ origin, destination, scales, info }) => ({
    origin: origin || info?.origin,
    destination: destination || info?.destination,
    scales: scales || info?.scales,
});

export const minimumLoadingTime = 2000;

export const cancellationReasons = [
    { value: "CANCELLED_BY_CLIENT", label: i18n.t("CancellationImputableToClient") },
    { value: "CANCELLED_BY_ROMBO", label: i18n.t("CancellationImputableToRombo") },
    { value: "CANCELLED_BY_CAPTURE_ERROR", label: i18n.t("CancellationCaptureError") }
];

export const statusMap = {
    DELETED: "Cancelled",
    FINISHED: "Completed",
    ASSIGNED: "Assigned",
    UNASSIGNED: "Unassigned",
    STARTED: "Started",
};

export const isPartnerAllowed = (partnerId) => {
    const allowedPartners = [3764, 4356, 5300, 4661, 3891, 3896]; 
    return allowedPartners.includes(Number(partnerId));
};

export const getFrequentAddresses = (companyId, employeeAddresses = []) => {
    const companyAddresses = [];
    
    if ([1, 6823].includes(companyId)) {
        companyAddresses.push(
            "Norte 45 847 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
            "Calle Pte. 128 550 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
            "Calz. Vallejo 1849 San José de la Escalera, Gustavo A. Madero, 07630 Ciudad de México, CDMX"
        );
    } else if ([3867, 4355].includes(companyId)) {
        companyAddresses.push(
            "Av. de los Insurgentes Sur 3500, Manantial Peña Pobre, Tlalpan, 14060 Ciudad de México, CDMX"
        );
    } else if ([3996, 4362].includes(companyId)) {
        companyAddresses.push(
            "Rosa Blanca 63, Molino de Rosas, Álvaro Obregón, 01470 Ciudad de México, CDMX"
        );
    } else if ([7784].includes(companyId)) {
        companyAddresses.push(
            "Periódico Reforma, Avenida México Coyoacán, Santa Cruz Atoyac, Ciudad de México, CDMX"
        );
    }
    
    const employeeAddressList = employeeAddresses.map(addr => addr.address.description);
    
    return [...new Set([...companyAddresses, ...employeeAddressList])];
};

export const handleSearchFilters = (
    val,
    typeSearch,
    filtersOpts,
    setFiltersOpts,
    setReloadList,
    setCurrentPage,
    localStorageKey,
    setStateFunctions = {}
  ) => {
    let opts = { ...filtersOpts };
  
    switch (typeSearch) {
      case FilterType.COMPANY:
        if (val) opts.data.filters.partner_id = val;
        else delete opts.data.filters.partner_id;
        if (setStateFunctions.setFCompany) setStateFunctions.setFCompany(val);
        break;
      case FilterType.STATUS:
        if (val) opts.data.filters.status = val;
        else delete opts.data.filters.status;
        if (setStateFunctions.setStatusService) setStateFunctions.setStatusService(val);
        break;
      case FilterType.TYPE:
        if (val) opts.data.filters.type = val;
        else delete opts.data.filters.type;
        if (setStateFunctions.setTypeService) setStateFunctions.setTypeService(val);
        break;
      case FilterType.CODE:
        if (val) opts.data.filters.code = val;
        else delete opts.data.filters.code;
        if (setStateFunctions.setServiceNumber) setStateFunctions.setServiceNumber(val || '');
        break;
      case FilterType.PLACE:
        if (val) opts.data.filters.place_id = val;
        else delete opts.data.filters.place_id;
        if (setStateFunctions.setPlaceService) setStateFunctions.setPlaceService(val);
        break;
        case FilterType.SCHEDULED:
        if (val) opts.data.filters.scheduled_type = val;
        else delete opts.data.filters.scheduled_type;
        if (setStateFunctions.setScheduledType) setStateFunctions.setScheduledType(val);
        break;
      case FilterType.PLATE:
        if (val) opts.data.filters.plate = val;
        else delete opts.data.filters.plate;
        if (setStateFunctions.setPlateService) setStateFunctions.setPlateService(val);
        break;
      case FilterType.PAGE:
        opts.data.filters.page = val;
        setCurrentPage(val);
        break;
      default:
        break;
    }
  
    if (typeSearch !== FilterType.PAGE) {
      opts.data.filters.page = 1;
      setCurrentPage(1);
    }
  
    if (Object.keys(opts.data.filters).length > 0) {
      localStorage.setItem(localStorageKey, JSON.stringify(opts));
    } else {
      localStorage.removeItem(localStorageKey);
    }
  
    setFiltersOpts(opts);
    setReloadList(true);
};

export const allowedHoursOptions = [
  { value: "22:10", label: "22:10" },
  { value: "22:30", label: "22:30" },
  { value: "23:10", label: "23:10" },
  { value: "23:30", label: "23:30" },
  { value: "01:10", label: "01:10" },
  { value: "01:30", label: "01:30" },
  { value: "02:10", label: "02:10" },
  { value: "02:30", label: "02:30" },
];  